import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Slider } from '@atlas/components';
import { Icon } from '@atlas/ui';

import { useIsRtl } from 'hooks/useIsRtl';

const StoreSlider = ({ children, slidesPerView = 'auto', spaceBetween = 8 }) => {
  const [swiper, setSwiper] = useState(null);
  const isRtl = useIsRtl();

  const prevSlide = () => swiper && swiper.slidePrev();
  const nextSlide = () => swiper && swiper.slideNext();

  return (
    <div className="store-slider">
      <button
        className="store-slider__arrow store-slider__arrow--prev"
        onClick={prevSlide}
        type="button"
      >
        <Icon name="arrow-left" />
      </button>

      <Slider
        autoplay={false}
        dir={isRtl ? 'rtl' : 'ltr'}
        loop={false}
        onBeforeInit={setSwiper}
        slidesPerView={slidesPerView}
        spaceBetween={spaceBetween}
      >
        {children}
      </Slider>

      <button
        className="store-slider__arrow store-slider__arrow--next"
        onClick={nextSlide}
        type="button"
      >
        <Icon name="arrow-right" />
      </button>
    </div>
  );
};

StoreSlider.Slide = Slider.Slide;

StoreSlider.propTypes = {
  children: PropTypes.node,
  slidesPerView: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  spaceBetween: PropTypes.number,
};

export default StoreSlider;
